<template>
  <splash v-show="is_load"></splash>

  <div class="card card-body card-procces-id-main-box mb-5 border-0">
    <div class="row d-flex justify-content-start">
      <div class="d-flex justify-content-between">
        <h3 style="font-size: 1.2vw !important;">مشخصات فعاليت‏‌های فرآيند</h3>
      </div>

      <br>
      <br>
      <br>
      <hr>
      <br>
    </div>

    <div class="table-responsive">

      <table class="table table-striped" style="width: 70vw; ">
        <thead>
        <tr>
          <th>ردیف</th>
          <th style="width: 5vw;">گروه فرآیند</th>
          <th> فرآیند</th>
          <th style="width: 15vw;">عنوان فعالیت</th>
          <th>سمت متولی</th>
          <th>نام متولی</th>
          <th style="width: 3vw ;">آیا مکانیزه است؟</th>
          <th style="width: 7vw;">متوسط زمان اجرا(دقیقه)</th>
          <th style="width: 7vw;">تواتر اجرا</th>
          <th style="width: 7vw;">محاسبات</th>

          <th style="width: 6vw;">عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr class="addCopy">
          <td>#</td>
          <td>
            <input v-model="showListprocessModel" class="form-control" type="text" name="" readonly
                   style="width: 6.3vw;"
                   placeholder="انتخاب کنید" @click.prevent="showListprocess">
          </td>
          <td>
            <input v-model="showListprocessModelTwo" class="form-control" type="text" name="" readonly
                   style="width: 6.3vw;"
                   placeholder="انتخاب کنید" @click.prevent="showListprocessTwo">
          </td>
          <td>
            <textarea v-model="title" class="form-control" cols="30" rows="10"></textarea>
          </td>
          <td>
            <input v-model="inserterName" class="form-control" type="text" style="width: 6.3vw;" readonly
                   placeholder="انتخاب کنید" @click.prevent="showListInserter">
          </td>
          <td>
            <input v-model="inserterNameTwo" class="form-control" type="text" style="width: 6.3vw;" readonly
                   placeholder="انتخاب کنید" @click.prevent="showListInserterTwo">
          </td>
          <td>
            <select style="width: 4.3vw;" v-model="mechanic" class="form-select">
              <option value="" disabled selected></option>
              <option value="1">بله</option>
              <option value="0">خیر</option>
            </select>
          </td>
          <td>
            <input v-model="frequency" class="form-control" type="text" name="" required>
          </td>
          <td>
            <input style="width: 5vw;" v-model="time" class="form-control" type="number" name="" required>
          </td>

          <td>
            <input :value="time*frequency" class="form-control" disabled type="text" name="" required>
          </td>

          <td>
            <button type="submit"
                    style=" font-size: 1vw; width: 2vw; background-color: unset; border: unset;">
              <span class="d-flex">
                   <Save v-show="!editModal && is_clone" @click.prevent="saveItem" title="ذخیره" style="width: 2.4vw;"/>
                   <Edit v-show="editModal && !is_clone" @click.prevent="update(item_id)" title="ویرایش" style="width: 2.4vw;"/>
              <Reset v-show="!editModal" @click.prevent="resetData" title="رست"
                     style="width: 2.4vw; margin-right: 0.2vw;"/>
              <Reset v-show="editModal" @click="resetDataTwo" title="لغو" style="width: 2.4vw; margin-right: 0.2vw;"/>
              </span>
            </button>
          </td>
        </tr>
        <tr v-for="(item,index) in all_items" :id="`item_${item.id}`">
          <td scope="row">{{ index + 1 }}</td>
          <td>{{ item.process && item.process.parent && item.process.parent.title }}</td>
          <td>{{ item.process && item.process.title }}</td>
          <td>{{ item.title }}</td>

          <td>
            <small v-if="item.TasksProcessForOrganizationposts.length !== 0" v-for="item2 in item.TasksProcessForOrganizationposts" :key="item2.organizationposts?.id">
              {{ item2.organizationposts && item2.organizationposts.name }}
              <span style="margin-left: 0.2vw;" v-if="item2.organizationposts && item2.organizationposts.id !== null && item2 !== item.TasksProcessForOrganizationposts[item.TasksProcessForOrganizationposts.length - 1]">،</span>
            </small>
            <small v-else>--</small>
          </td>

          <td>
            <small v-if="item.users.length" v-for="(item3, index) in item.users"  :key="item.users?.id">
              {{ item3?.fullname }}
              <span style="margin-left: 0.2vw;" v-if="item3 && item3.id !== null && index !== item.users.length - 1">،</span>
            </small>
            <small v-else>--</small>
          </td>

          <td>{{item.mechanic}}</td>
          <td>{{ item.frequency }}</td>
          <td>{{ item.average_time }}</td>
          <td>
            {{item.calculation}}
          </td>
          <td>
            <div class="d-flex justify-content-evenly w-100">
              <p style="width: 2vw;" @click.prevent="deleteModalMethod(item.id)" href="#"><img
                  class="table-delete-img mx-2" src="/img/delete.f9fc94bc.svg" alt="delete"></p>
              <a style="width: 2vw; transform: translateX(-0.2vw)" @click.prevent="edit(item.id)" href="#"><img
                  class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
              <a style="width: 2vw; " href="#">
                <PlusIcon
                    @click.prevent="cloneItem2(item.id, item.process.id,item.process.title,  item.process.parent_id,item.mechanic ==='بله' ? '1' : '0')"
                    style="width: 1.5vw;"/>

              </a>
            </div>
          </td>
        </tr>

        </tbody>
      </table>
    </div>
    {{ scroll }}
  </div>
  <!-- ************************************** -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter"
       :style="{ top: modalTop + 'px' }"
       style="z-index: 999999999999999999999999999999999999999999999; ">
    <div>
      <p>سمت متولی </p>
      <p @click="select_inserter=!select_inserter">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <div style="width: 100%;height: 25vw;overflow: auto;">
        <table class="table table-striped">
          <thead>
          <tr>
            <th style="width: 1vw;">انتخاب</th>
            <th>کد</th>
            <th>عنوان</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in filteredorganization" :key="item.id">
            <td scope="row"><input :id="`s4_${item.id}`" v-model="inserterId" type="checkbox" name="parent"
                                   :value="item['id']"></td>
            <td>
              <label :for="`s4_${item.id}`">
                {{ item['id'] }}
              </label>
            </td>
            <td>
              <label :for="`s4_${item.id}`">
                {{ item['name'] }}
              </label>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <button @click="select_inserterMethod">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserterTwo"
       :style="{ top: modalTop + 'px' }"
       style="z-index: 999999999999999999999999999999999999999999999; ">
    <div>
      <p>نام متولی </p>
      <p @click="select_inserterTwo=!select_inserterTwo">❌</p>
    </div>
    <div>
      <input v-model="search_inserterTwo" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <div style="width: 100%;height: 25vw;overflow: auto;">
        <table class="table table-striped">
          <thead>
          <tr>
            <th style="width: 1vw;">انتخاب</th>
            <th>کد</th>
            <th>عنوان</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in filteredorganizationTwo" :key="item.id">
            <td scope="row"><input :id="`s3_${item.id}`" v-model="inserterIdTwo" type="checkbox" name="parent"
                                   :value="item['id']"></td>
            <td>
              <label :for="`s3_${item.id}`">
                {{ item['id'] }}
              </label>
            </td>
            <td>
              <label :for="`s3_${item.id}`">
                {{ item['name'] }}
              </label>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <button @click="select_inserterMethodTwo">تایید</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" :style="{ top: modalTop + 'px' }">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; ">
    <div>
      <p> خطا </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{ errorMessage }}


      <button @click="error=!error">بازگشت</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="allUserModal"
       :style="{ top: modalTop + 'px' }"

       style="z-index: 999999999999999999999999999999999999999999999; ">
    <div>
      <p> پست سازمانی</p>
      <p @click="allUserModal=!allUserModal">❌</p>
    </div>
    <div>
      <div style="width: 100%;height: 25vw;overflow: auto;">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>ردیف</th>
            <th>پست سازمانی</th>

          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in allUser" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.organizationposts.name }}</td>

          </tr>

          </tbody>
        </table>
      </div>


      <button @click="allUserModal=!allUserModal">بازگشت</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allUserModalTwo"
       :style="{ top: modalTop + 'px' }"

       style="z-index: 999999999999999999999999999999999999999999999; ">
    <div>
      <p> متولی </p>
      <p @click="allUserModalTwo=!allUserModalTwo">❌</p>
    </div>
    <div>
      <table class="table table-striped">
        <thead>
        <tr>
          <th>ردیف</th>
          <th>نام و نام خانوادگی</th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in allUserTwo" :key="item.id">
          <td>{{ index + 1 }}</td>
          <td>{{ item.user.fullname }}</td>

        </tr>

        </tbody>
      </table>


      <button @click="allUserModalTwo=!allUserModalTwo">بازگشت</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="search_allProcessesModal"
       :style="{ top: modalTop + 'px' }"
       style="z-index: 999999999999999999999999999999999999999999999; ">
    <div>
      <p>گروه فرآیند</p>
      <p @click="search_allProcessesModal=!search_allProcessesModal">❌</p>
    </div>
    <div>
      <input v-model="search_allProcesses" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و نام فرآیند  ...">
      <div style="width: 100%; height: 25vw; overflow: auto;">
        <table class="table table-striped">
          <thead>
          <tr>
            <th style="width: 1vw;">انتخاب</th>
            <th>کد</th>
            <th>عنوان</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in search_allProcessesFiltered" :key="item.id">
            <td scope="row"><input :id="`s2_${item.id}`" v-model="PId" type="radio" name="parent" :value="item['id']">
            </td>
            <td>
              <label :for="`s2_${item.id}`">
                {{ item['code'] }}
              </label>
            </td>
            <td>
              <label :for="`s2_${item.id}`">
                {{ item['title'] }}
              </label>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <button @click="select_ProcessesMethod">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="search_allProcessesModalTwo"
       :style="{ top: modalTop + 'px' }"
       style="z-index: 999999999999999999999999999999999999999999999; ">
    <div>
      <p>فرآیند </p>
      <p @click="search_allProcessesModalTwo=!search_allProcessesModalTwo">❌</p>
    </div>
    <div>
      <input v-model="search_allProcessesTwo" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و نام فرآیند  ...">
      <div style="width: 100%; height: 25vw; overflow: auto;">
        <table class="table table-striped">
          <thead>
          <tr>
            <th style="width: 1vw;">انتخاب</th>
            <th>کد</th>
            <th>عنوان</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in search_allProcessesTwoFiltered" :key="item.id">
            <td scope="row"><input :id="`s1_${item.id}`" v-model="PIdTwo" type="radio" name="parent"
                                   :value="item['id']"></td>
            <td>
              <label :for="`s1_${item.id}`">
                {{ item['code'] }}
              </label>
            </td>
            <td>
              <label :for="`s1_${item.id}`">
                {{ item['title'] }}
              </label>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <button @click.prevent="select_ProcessesTwoMethod">تایید</button>
    </div>
  </div>
</template>
<script>
import {mapMutations, mapState} from "vuex";
import {all} from "core-js/internals/document-all";
import process_id from "@/views/process/proccess_id/process_id.vue";
import PlusIcon from "@/components/Icons/PlusIcon.vue";
import Save from "@/components/Icons/Save.vue";
import Reset from "@/components/Icons/Reset.vue";
import Edit from "@/components/Icons/Edit.vue";
import {useToast} from "vue-toastification";
import Splash from "@/components/Splash/SplashWait.vue";

const toast = useToast();
export default {
  components: {Splash, Edit, Reset, Save, PlusIcon},
  props: ['id_route', 'type'],
  data() {
    return {
      all_items: [],
      allProcesses: [],
      allProcessesTwo: [],
      allUser: [],
      allUserTwo: [],
      is_load: true,
      allUserModal: false,
      cloneAllModal: false,
      allUserModalTwo: false,
      all_inserter: [],
      all_inserterTwo: [],
      select_inserter: false,
      deleteModal: false,
      editModal: false,
      search_inserter: '',
      search_inserterTwo: '',
      search_allProcesses: '',
      search_allProcessesTwo: '',
      inserterId: [],
      inserterIdTwo: [],
      PId: '',
      PIdTwo: '',
      title: '',
      owner: '',
      mechanic: '',
      inserterName: '',
      inserterNameTwo: '',
      type: '',
      time: '',
      frequency: '',
      prerequisite: '',
      item_id: '',
      supplier: 1,
      error: false,
      errorMessage: false,
      is_references: false,
      search_allProcessesModal: false,
      references: '',
      text: '',
      search_allProcessesModalTwo: '',
      showListprocessModel: '',
      showListprocessModelTwo: '',
      select_inserterTwo: false,
      id_clone: '',
      modalTop: '',
      windowTop: '',
      scroll: '',
      is_clone: true,


    }
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll)
  },
  methods: {
    onScroll(e) {
      this.windowTop = window.top.scrollY /* or: e.target.documentElement.scrollTop */
    },
    handleScroll() {
      // محاسبه موقعیت جدید بر اساس اسکرول
      this.modalTop = window.scrollY || document.documentElement.scrollTop;
      if (this.modalTop === 0) {
        this.modalTop = 195
      }
    },
    submitCloneAll() {
      fetch(`${this.base_url}/tasks_process/store_clone`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message) {
              this.cloneAllModal = false
              toast.success(response.message)

            }

          }).catch((err) => {
      })
    },
    cloneAll() {
      this.cloneAllModal = true
    },
    select_ProcessesMethod() {

      this.search_allProcessesModal = false
      this.search_allProcessesFiltered.forEach((item) => {
        item.id === this.PId ? this.showListprocessModel = item.title : ''
      })


    },
    select_ProcessesTwoMethod() {
      this.search_allProcessesModalTwo = false
      this.search_allProcessesTwoFiltered.forEach((item) => {
        item.id === this.PIdTwo ? this.showListprocessModelTwo = item.title : ''
      })


    },
    fetchAllProcessesTwo() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all_other_id/${this.PId}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            if (result.items.length) {
              this.allProcessesTwo.length = 0
              result.items.forEach((ele) => {
                this.allProcessesTwo.push(ele)


              })
            }


          })
          .catch();


    },
    fetchAllProcesses() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all_for_job`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            if (result.items.length) {
              this.allProcesses.length = 0
              result.items.forEach((ele) => {
                this.allProcesses.push(ele)


              })
            }


          })
          .catch();


    },
    showListprocess() {
      this.fetchAllProcesses()
      this.search_allProcessesModal = true
      this.handleScroll()
    },
    showListprocessTwo() {
      this.fetchAllProcessesTwo()
      this.search_allProcessesModalTwo = true
      this.handleScroll()

    },
    allUsersMethod(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/show_or/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              this.allUser.length = 0
              response.all.forEach((item) => {
                this.allUser.push(item)
              })
              this.allUserModal = true
            }


          })
          .catch();
    },
    allUsersMethodTwo(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/show_users/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              this.allUserTwo.length = 0
              response.all.forEach((item) => {
                this.allUserTwo.push(item)
              })
              this.allUserModalTwo = true
            }


          })
          .catch();
    },
    allUsersMethodForedit(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/show_or/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              this.allUser.length = 0
              response.all.forEach((item) => {
                this.allUser.push(item)
              })
            }


          })
          .catch();
    },
    deleteModalMethod(id) {
      this.item_id = id
      this.deleteModal = true
      this.handleScroll()

    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.deleteModal = false


          })
          .catch();
    },
    edit(id) {
      this.item_id = id
      this.editModal = true
      this.is_clone = false
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            const item = response.item
            if (item) {
              this.cloneItem(item.id, item.process.id, item.process.title, item.process.parent_id, this.mechanic = item.mechanic === 'بله' ? 1 : 0)
              this.title = item.title
              this.time = item.average_time
              this.prerequisite = item.prerequisite
              this.frequency =item.frequency
              this.owner = item.owner
              this.text = item.text
              this.references = item.references
              this.is_references = item.is_references === 'بله' ? '1' : '0'

              this.mechanic = item.mechanic === 'بله' ? '1' : '0'
              this.allUsersMethodForedit(id)
              this.allUser.forEach((ele) => {
                this.inserterId.push(ele.organizationposts_id)
              })
              this.allUserModal = false


            }


          })
          .catch();
    },
    update(id) {
      if (!this.$cookies.isKey('is_mother')) {
        if (!this.PIdTwo) {
          toast.error('گروه فرآیند و فرآیند آن اجباری است!')
          return;

        } else if (!this.title) {
          toast.error('عنوان فعالیت  اجباری است')
          return;

        } else if (this.inserterId.length === 0) {
          toast.error('سمت متولی اجباری است')
          return;

        } else if (this.inserterIdTwo.length === 0) {
          toast.error('نام متولی اجباری است')
          return;

        } else if (!this.mechanic) {
          toast.error(' مکانیزه است اجباری است')
          return;

        } else if (!this.time) {
          toast.error(' متوسط زمان اجرا اجباری است')
          return;

        } else if (!this.frequency) {
          toast.error('تواتر اجباری است')
          return;

        }
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('organizationposts_id', JSON.stringify(this.inserterId))
      formdata.append('users_id', JSON.stringify(this.inserterIdTwo))
      formdata.append('processes_id', this.PIdTwo)
      formdata.append('title', this.title)
      formdata.append('average_time', this.time)
      formdata.append('frequency', this.frequency)
      formdata.append('prerequisite', this.prerequisite)
      formdata.append('owner', this.owner)
      formdata.append('text', this.text)
      formdata.append('references', this.references)
      formdata.append('is_references', this.is_references)
      formdata.append('mechanic', this.mechanic)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()


            this.resetData()
            this.editModal = false
            if (response.id) {
              this.NextItem(response.id)
            }



          })
          .catch();
    },
    NextItem(id) {
      const index = this.all_items.findIndex(item => item.id === id);
      // بررسی آیا آیتم با آی‌دی داده شده آخرین آیتم در لیست است یا نه
      if (index < this.all_items.length - 1) {
        // در این صورت به آیتم همسایه بعدی می‌رویم
        const nextItemId = this.all_items[index + 1].id;
        const nextItemElement = document.getElementById(`item_${nextItemId}`);
        if (nextItemElement) {
          // اسکرول به آیتم همسایه بعدی
          nextItemElement.scrollIntoView({behavior: 'smooth'});
          const elementToMove = document.querySelector('.addCopy');
          nextItemElement.parentNode.insertBefore(elementToMove, nextItemElement.nextSibling);


          this.edit(nextItemId)
        }
      }

    },
    cloneItem(id, p_id, p_title, p_parent_id, select_item) {

      this.resetData()
      const elementToMove = document.querySelector('.addCopy');
      const targetElement = document.getElementById(`item_${id}`);
      if (targetElement && targetElement.nextSibling) {
        targetElement.parentNode.insertBefore(elementToMove, targetElement.nextSibling);
      }
      this.resetData()


      this.showListInserter()
      this.showListInserterTwo()
      this.id_clone = id
      this.select_inserter = false
      this.select_inserterTwo = false
      this.showListprocessModelTwo = p_title
      this.PIdTwo = p_id
      this.mechanic = select_item
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/parent_process/${p_parent_id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.showListprocessModel = response.item.title
            this.PId = response.item.id
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


            var formdata = new FormData();


            var requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: formdata,
              redirect: 'follow'
            };
            fetch(`${this.base_url}/tasks_process/show_or/${id}`, requestOptions)
                .then(response => response.json())
                .then(response => {
                  if (response.all) {
                    this.inserterId.length = 0
                    response.all.forEach((item) => {

                      this.inserterId.push(item.organizationposts_id)
                    })
                    this.select_inserterMethod()
                    var myHeaders = new Headers();
                    myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


                    var formdata = new FormData();


                    var requestOptions = {
                      method: 'POST',
                      headers: myHeaders,
                      body: formdata,
                      redirect: 'follow'
                    };
                    fetch(`${this.base_url}/tasks_process/show_users/${id}`, requestOptions)
                        .then(response => response.json())
                        .then(response => {
                          if (response.all) {
                            this.inserterIdTwo.length = 0
                            response.all.forEach((item) => {
                              this.inserterIdTwo.push(item.user_id)
                            })
                            this.select_inserterMethodTwo()

                          }
                        })
                        .catch();
                  }


                })
                .catch();

          })
          .catch();


    },cloneItem2(id, p_id, p_title, p_parent_id, select_item) {

      this.resetData()
      const elementToMove = document.querySelector('.addCopy');
      const targetElement = document.getElementById(`item_${id}`);
      if (targetElement && targetElement.nextSibling) {
        targetElement.parentNode.insertBefore(elementToMove, targetElement.nextSibling);
      }
      this.resetData()
      this.editModal = false

      this.is_clone = true

      this.showListInserter()
      this.showListInserterTwo()
      this.id_clone = id
      this.select_inserter = false
      this.select_inserterTwo = false
      this.showListprocessModelTwo = p_title
      this.PIdTwo = p_id
      this.mechanic = select_item
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/parent_process/${p_parent_id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.showListprocessModel = response.item.title
            this.PId = response.item.id
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


            var formdata = new FormData();


            var requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: formdata,
              redirect: 'follow'
            };
            fetch(`${this.base_url}/tasks_process/show_or/${id}`, requestOptions)
                .then(response => response.json())
                .then(response => {
                  if (response.all) {
                    this.inserterId.length = 0
                    response.all.forEach((item) => {

                      this.inserterId.push(item.organizationposts_id)
                    })
                    this.select_inserterMethod()
                    var myHeaders = new Headers();
                    myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


                    var formdata = new FormData();


                    var requestOptions = {
                      method: 'POST',
                      headers: myHeaders,
                      body: formdata,
                      redirect: 'follow'
                    };
                    fetch(`${this.base_url}/tasks_process/show_users/${id}`, requestOptions)
                        .then(response => response.json())
                        .then(response => {
                          if (response.all) {
                            this.inserterIdTwo.length = 0
                            response.all.forEach((item) => {
                              this.inserterIdTwo.push(item.user_id)
                            })
                            this.select_inserterMethodTwo()

                          }
                        })
                        .catch();
                  }


                })
                .catch();

          })
          .catch();


    },
    resetData() {
      this.inserterId.length = 0
      this.inserterIdTwo.length = 0
      this.title = ''
      this.inserterName = ''
      this.inserterNameTwo = ''
      this.title = ''
      this.time = ''
      this.frequency = ''
      this.prerequisite = ''
      this.inserterId.length = 0
      this.owner = ''
      this.text = ''
      this.references = ''
      this.is_references = ''
      this.mechanic = ''
      this.PIdTwo = ''
      this.PId = ''
      this.showListprocessModel = ''
      this.showListprocessModelTwo = ''
      this.id_clone = ''


    },
    resetDataTwo() {
      this.inserterId.length = 0
      this.inserterIdTwo.length = 0
      this.title = ''
      this.inserterName = ''
      this.inserterNameTwo = ''
      this.title = ''
      this.time = ''
      this.frequency = ''
      this.prerequisite = ''
      this.inserterId.length = 0
      this.owner = ''
      this.text = ''
      this.references = ''
      this.is_references = ''
      this.mechanic = ''
      this.PIdTwo = ''
      this.PId = ''
      this.showListprocessModel = ''
      this.showListprocessModelTwo = ''
      this.editModal = false
    },
    saveItem() {

      if (!this.$cookies.isKey('is_mother')) {
        if (!this.PIdTwo) {
          toast.error('گروه فرآیند و فرآیند آن اجباری است!')
          return;

        } else if (!this.title) {
          toast.error('عنوان فعالیت  اجباری است')
          return;

        } else if (this.inserterId.length === 0) {
          toast.error('سمت متولی اجباری است')
          return;

        } else if (this.inserterIdTwo.length === 0) {
          toast.error('نام متولی اجباری است')
          return;

        } else if (!this.mechanic) {
          toast.error(' مکانیزه است اجباری است')
          return;

        } else if (!this.time) {
          toast.error(' متوسط زمان اجرا اجباری است')
          return;

        } else if (!this.frequency) {
          toast.error('تواتر اجباری است')
          return;

        }
      } else {
        if (!this.PIdTwo) {
          toast.error('گروه فرآیند و فرآیند آن را انتخاب نمایید!')
          return;

        } else if (!this.title) {
          toast.error('عنوان فعالیت  اجباری است')
          return;

        }
      }


      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('organizationposts_id', JSON.stringify(this.inserterId))
      formdata.append('users_id', JSON.stringify(this.inserterIdTwo))
      formdata.append('processes_id', this.PIdTwo)
      formdata.append('title', this.title)
      formdata.append('average_time', this.time)
      formdata.append('frequency', this.frequency)
      formdata.append('prerequisite', this.prerequisite)
      formdata.append('owner', this.owner)
      formdata.append('text', this.text)
      formdata.append('references', this.references)
      formdata.append('is_references', this.is_references)
      formdata.append('mechanic', this.mechanic)
      if (this.id_clone) {
        formdata.append('id_clone', this.id_clone)

      }


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }

            this.addToSharedList()
            this.showItem()
            this.resetData()
            setTimeout(() => {
              this.cloneItem(response.id, response.process_id, response.process_title, response.parent_id, response.mechanic === 'بله' ? 1 : 0);

              // یافتن آیتم مورد نظر
              const targetElement = document.getElementById(`item_${response.id}`);

              // اگر آیتم موجود است، اسکرول به آن
              if (targetElement) {
                // محاسبه موقعیت آیتم
                const targetPosition = targetElement.offsetTop;

                // اسکرول به موقعیت آیتم
                window.scrollTo({
                  top: targetPosition,
                  behavior: 'smooth' // انیمیشن اسکرول
                });
              }
            }, 3000);

          })
          .catch();

    },
    getInformations() {
      if (!this.PId) return;
      fetch(`${this.base_url}/processes/information_by_id/${this.PId}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response) {
              if (response.item) {
                this.type = response.item.type

              }

            }

          }).catch((err) => {
      })
    },
    // *************************************************
    // *************************************************
    // *************************************************
    ...mapMutations(['setSharedList']),
    addToSharedList() {
      this.setSharedList(true);

    },
    showListInserter() {
      this.handleScroll()

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter.length = 0
            let uniqueNames = new Set();

            result['all'].forEach(item => {
              if (!uniqueNames.has(item.name)) {
                uniqueNames.add(item.name);
                this.all_inserter.push(item);
              }
            });


          })
          .catch();
      this.select_inserter = true
    },
    showListInserterTwo() {
      this.handleScroll()

      this.select_inserterTwo = true
    },
    showItem() {
      this.is_load = true

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/all_no_id`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              this.all_items.length = 0

              response.all.forEach((item) => {
                this.all_items.push(item)
              })


              this.is_load = false
            }
            if (response.paginate) {
              if (response.paginate.next_page_url) {
                this.page_number = response.paginate.next_page_url
                this.showItemPages()
              }
            }


          })
          .catch();

    },
    showItemPages() {
      this.is_load = true

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.page_number}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              response.all.forEach((item) => {
                this.all_items.push(item)
              })


              this.is_load = false
            }
            if (response.paginate) {
              if (response.paginate.next_page_url > this.page_number) {
                this.page_number = response.paginate.next_page_url

                this.showItemPages()

              }
            }


          })
          .catch();

    },
    select_inserterMethod() {

      // اطمینان حاصل کنید inserterId یک آرایه از اعداد یا رشته‌ها است
      if (Array.isArray(this.inserterId)) {
        // متغیر برای نگهداری نتیجه
        let resultString = '';

        // بررسی هر عنصر در inserterId
        this.inserterId.forEach((id, index) => {
          // یافتن متن متناظر با id
          const matchingElement = this.all_inserter.find(ele => ele.id === id);

          // اگر یک متن متناظر پیدا شود، اضافه کردن به نتیجه
          if (matchingElement) {
            resultString += matchingElement.name;

            // اگر عنصر آخری نبود، خط تست را اضافه کنید
            if (index < this.inserterId.length - 1) {
              resultString += ' - ';
            }
          }
        });

        // نتیجه را در inserterName قرار دهید
        this.inserterName = resultString;

        // تغییر وضعیت select_inserter به false
        this.select_inserter = false;
      }
      this.select_inserter = false
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('id', JSON.stringify(this.inserterId))


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all_from_job`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              this.all_inserterTwo.length = 0
              let uniqueNames = new Set();

              response['all'].forEach(item => {
                if (!uniqueNames.has(item.name)) {
                  uniqueNames.add(item.name);
                  this.all_inserterTwo.push(item);
                }
              });


            }


          })
          .catch();


    },
    select_inserterMethodTwo() {

      // اطمینان حاصل کنید inserterId یک آرایه از اعداد یا رشته‌ها است
      if (Array.isArray(this.inserterIdTwo)) {
        // متغیر برای نگهداری نتیجه
        let resultString = '';

        // بررسی هر عنصر در inserterId
        this.inserterIdTwo.forEach((id, index) => {
          // یافتن متن متناظر با id
          const matchingElement = this.all_inserterTwo.find(ele => ele.id === id);

          // اگر یک متن متناظر پیدا شود، اضافه کردن به نتیجه
          if (matchingElement) {
            resultString += matchingElement.name;

            // اگر عنصر آخری نبود، خط تست را اضافه کنید
            if (index < this.inserterIdTwo.length - 1) {
              resultString += ' - ';
            }
          }
        });

        // نتیجه را در inserterName قرار دهید
        this.inserterNameTwo = resultString;

        // تغییر وضعیت select_inserter به false
        this.select_inserterTwo = false;
      }
      this.select_inserterTwo = false


    },


  },
  computed: {
    process_id() {
      return process_id
    },
    all() {
      return all
    },
    ...mapState(['statusInformation']),
    filteredorganization() {
      return this.all_inserter.filter(item => {
        return (
            item['name'].includes(this.search_inserter) ||
            item['id'].toString().includes(this.search_inserter)
        );
      });
    },
    filteredorganizationTwo() {
      return this.all_inserterTwo.filter(item => {
        return (
            item['name'].includes(this.search_inserterTwo) ||
            item['id'].toString().includes(this.search_inserterTwo)
        );
      });
    },
    search_allProcessesFiltered() {
      return this.allProcesses.filter(item => {
        return (
            item['title'].includes(this.search_allProcesses) ||
            item['code'].toString().includes(this.search_allProcesses)
        );
      });
    },
    search_allProcessesTwoFiltered() {
      return this.allProcessesTwo.filter(item => {
        return (
            item['title'].includes(this.search_allProcessesTwo) ||
            item['code'].toString().includes(this.search_allProcessesTwo)
        );
      });
    },
  },
  mounted() {
    this.getInformations()
    this.showItem()
    // window.addEventListener("scroll", this.onScroll)
  },
  /*watch:{
    windowTop : function (old, newModal){
      this.scroll = newModal
      console.log(newModal)
      if (parseInt(newModal)===3552 ){
        this.showItemPages()
      }else{

      }


    }
  }*/

}

</script>
<style scoped>
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: #D0E9FA57;
  color: var(--bs-table-striped-color);
}
</style>